<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-9">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-md-3">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>

  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'label'" [idOpcion]="'idCalendario'"
          [comboBox]="listCalendarios" formControlName="idCalendario" [control]="formulario.get('idCalendario')"
          [label]="'Calendario *'" [id]="'idCalendario'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="idVendedorTipo" [control]="formulario.get('idVendedorTipo')"
          [label]="'Tipo de Vendedor *'" [id]="'idVendedorTipo'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>

</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Asignación de Calendario'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-12">
        <app-lfsa-input [isReadOnly]="true" [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese ID'"
          [label]="'ID *'" [id]="'idCalendario'" formControlName="idCalendario"
          [control]="formulario.get('idCalendario')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'periodo'" [idOpcion]="'idCalendario'"
          [comboBox]="listCalendarios" formControlName="idCalendario" [control]="formulario.get('idCalendario')"
          [label]="'Calendario *'" [id]="'idCalendario'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="idVendedorTipo" [control]="formulario.get('idVendedorTipo')"
          [label]="'Tipo de Vendedor *'" [id]="'idVendedorTipo'">
        </app-lfsa-combo-box>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>